export const platforms= [
  // {
  //     label: 'eRef (complete)',
  //     value: 'eref',
  // },
  {
    label: "eRef Lehrbücher",
    value: "eref-del",
  },
  // {
  //     label: 'I care',
  //     value: 'icare',
  // },
  // {
  //     label: 'MedOne (complete)',
  //     value: 'medone',
  // },
  {
    label: "MedOne Education",
    value: "medone-tebl",
  },
  // {
  //     label: 'Osteothek',
  //     value: 'osteothek',
  // },
  {
    label: 'Pharmaceutical Substances',
    value: 'ps',
  },
  {
    label: "RÖMPP",
    value: "roempp",
  },
  {
    label: "RÖMPP SciCapsules",
    value: "roempp_sci",
  },
  {
      label: 'Science of Synthesis',
      value: 'sos',
  },
  {
    label: "Thieme-Connect",
    value: "thieme-connect",
  }
  // {
  //     label: 'Vetcenter',
  //     value: 'vetcenter',
  // },
];
